import { round } from 'lodash'

export const getPotentialReturn = (odds: string | number, stake = 10) => {
  const parsedOdds = typeof odds === 'number' ? odds : parseFloat(odds)

  const decimalOdds = parsedOdds >= 0 ? parsedOdds / 100 + 1 : 100 / -parsedOdds + 1
  return round(decimalOdds * stake, 2)
}
